import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Participantes from '../participantes';
import DIALOGLOJADETALHE from 'dialog/dialoglojadetalhe';
import { Link } from 'react-router-dom';

const CarrosselParticipantes = ({ lparticipante }) => {
  const [pppDetalhe, setpppDetalhe] = useState(false);
  const [idestabelecimento, setIdEstabelecimento] = useState(0);

  const openDetalhe = (id) => {
    setIdEstabelecimento(id);
    setpppDetalhe(true);
  }
  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 4
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return <>
    <div className='mt-4'>
      <div className='d-flex align-items-center justify-content-between mb-3 px-2'>
        <h2 className='section-title mb-0'>Lojas Participantes</h2>
        <Link to="/meu/participantes" className="btn btn-primary btn-sm rounded-pill">
          <i className="fas fa-search me-1"></i> Ver todas
        </Link>
      </div>
      <div className='modern-carousel'>
        <Carousel 
          responsive={responsive} 
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          arrows={true}
          showDots={false}
        >
          {lparticipante.map(b => (
            <div key={`estb${b.id_estabelecimento}`} className='p-2'>
              <Participantes
                nome={b.nome}
                endereco={`${b.endereco},${b.complemento}`}
                telefone={b.telefone}
                whatsup={b.whatsup}
                foto={b.url_foto}
                logo={b.url_logo}
                dados={b}
                site={openDetalhe}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
    <DIALOGLOJADETALHE
      trigger={pppDetalhe}
      setTrigger={setpppDetalhe}
      dados={idestabelecimento}
    />
  </>
};

export default CarrosselParticipantes;
